// Width of the editor's editable "page" in CSS pixels.
//
// The manual is rendered to PDF by wkhtmltopdf (A4 portrait, 595x842 pt) with
// Zoom 0.95 and smart-shrinking disabled. The actual text column measured from a
// sample PDF is 531.7pt (~709px @96dpi). Because wkhtmltopdf lays the HTML out in
// a larger virtual viewport and scales it down by the 0.95 zoom (browser zoom
// preserves line wrapping), the editor — which renders at zoom 1.0 — must use the
// pre-zoom width to reproduce the same line breaks: 709px / 0.95 ≈ 750px.
//
// Tune this value if editor wrapping drifts from the generated PDF.
export const PDF_CONTENT_WIDTH_PX = 750;

// Horizontal padding of the white page sheet, in CSS pixels (per side). Purely
// cosmetic (simulates the print margins) — it does NOT affect the 750px text
// column. Shared between the page styling and the fit-to-width zoom math.
export const PDF_PAGE_X_PADDING_PX = 40;

// Total outer width of the page sheet (text column + both side paddings). Used to
// compute the "Fit width" zoom factor against the available canvas width.
export const PDF_PAGE_OUTER_WIDTH_PX =
  PDF_CONTENT_WIDTH_PX + 2 * PDF_PAGE_X_PADDING_PX;

// Editor zoom levels offered in the toolbar selector. "fit" auto-scales the page
// to the available width (clamped to <=100%); the numeric values are fixed scales.
export type ZoomLevel = "fit" | 1 | 1.25;

export const ZOOM_OPTIONS: { value: ZoomLevel; labelKey: string }[] = [
  { value: "fit", labelKey: "manual.zoom.fit" },
  { value: 1, labelKey: "manual.zoom.100" },
  { value: 1.25, labelKey: "manual.zoom.125" },
];

// Lower bound for the auto-fit factor so the page never becomes unreadably small.
export const MIN_FIT_ZOOM = 0.4;
